import axiosInstance from './axiosConfig';

// Dashboard card record getting here
export const dashboardSummariesCount = async ({ formattedEnd, formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/summaries/count?start_date=${formattedStart}&end_date=${formattedEnd}`,{ silent: true });
  return response.data;
};
export const dashboardKpiCategory = async ({ formattedEnd, formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/kpi/category?start_date=${formattedStart}&end_date=${formattedEnd}`,{ silent: true });
  return response.data;
};
// Dashboard total revenue record getting here
export const spendAnalysisRevenue = async ({ spendAnlysisFilter , formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/revenues/spend_analysis?filter=${spendAnlysisFilter}&start_date=${formattedStart}&end_date=${formattedEnd}`,{ silent: true });
  return response.data;
};

// Dashboard spend analysis record getting here
export const totalRevenueSales = async ({ totalRevenueFilter , formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/revenues/sales?filter=${totalRevenueFilter}&start_date=${formattedStart}&end_date=${formattedEnd}`,{ silent: true });
  return response.data;
};

// Dashboard Bussiness revenue record getting here
export const bussinessRevenue = async ({ formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/revenues/business?start_date=${formattedStart}&end_date=${formattedEnd}`,{ silent: true });
  return response.data;
};

// Dashboard Bussiness revenue record getting here
export const bussinessRevenueCount = async ({ formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/revenues/business?start_date=${formattedStart}&end_date=${formattedEnd}&type=count`,{ silent: true });
  return response.data;
};


// Dashboard Payment Mode record getting here
export const paymentMode = async ({ formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/revenues/payment_mode?start_date=${formattedStart}&end_date=${formattedEnd}`,{ silent: true });
  return response.data;
};


// Dashboard Dashboard sales by state record getting here
export const salesByState = async ({ formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/reports/sales_by_state?start_date=${formattedStart}&end_date=${formattedEnd}`,{ silent: true });
  return response.data;
};

// Dashboard top selling products record getting here
export const topSellingProducts = async ({ formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/reports/top_selling_products?start_date=${formattedStart}&end_date=${formattedEnd}`,{ silent: true });
  return response.data;
};

export const topSellingCategory = async ({ formattedEnd , formattedStart }) => {
  const response = await axiosInstance.get(`/dashboard/reports/top_selling_products?start_date=${formattedStart}&end_date=${formattedEnd}&group_by=category`);
  return response.data;
};

